import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';

import { asFetchableView } from '../../../_lib/ViewFetcher';
import { ImageUploadForm } from '../../../_lib/components/ImageUpload/ImageUploadForm';

type PortalLogoEditProps = {
  image: ProfileImage;
  cropping: boolean;
  viewportSwitch: boolean;
  form: IForm;
};

export function PortalLogoEdit({ image, form, cropping, viewportSwitch }: PortalLogoEditProps) {
  const { uuid } = useBlockContext();
  const { refresh } = useRefreshBlock();
  const { t } = useSonTranslation('PortalLogo');

  return (
    <ImageUploadForm
      imageDescriptionName={t('imageDescriptionName')}
      cropping={cropping}
      viewportSwitch={viewportSwitch}
      form={form}
      formId="portal-logo-image-upload-form"
      uuid={uuid}
      initialImage={image}
      refresh={refresh}
      additionalDescription={t('additionalDescription')}
    />
  );
}

export const PortalLogoEditView = asFetchableView(PortalLogoEdit);
export type PortalLogoEditView = ComponentProps<typeof PortalLogoEditView>;
